import React from 'react';
import {
  Copy,
  Check,
  ExternalLink,
  Globe,
  House,
  Save,
} from 'lucide-react';
import { PUBLIC_BASE } from '../constants';
import { LINK_PAGE_IMAGE } from '../../../../branding/assets';

export default function LinksConfigHero({
  navigate,
  active,
  setActive,
  slug,
  publicPath,
  handleSave,
  handleCopy,
  hasUnsavedChanges,
  saving,
  isUploadingImage,
  copied,
  saveError,
  saveMessage,
}) {
  return (
    <header className="fsl-hero">
      <div className="fsl-hero-glow" aria-hidden />
      <div className="fsl-hero-row">
        <button
          type="button"
          className="fsl-back-btn"
          onClick={() => navigate('/products')}
          aria-label="Voltar para produtos"
          title="Voltar para produtos"
        >
          <House size={21} strokeWidth={2.3} />
        </button>

        <div className="fsl-hero-brand">
          <div className="fsl-admin-brandmark">
            <img
              className="fsl-admin-brand-logo"
              src={LINK_PAGE_IMAGE}
              alt="LinkPage"
            />
          </div>
        </div>

        <button
          type="button"
          className={`fsl-status-pill ${active ? 'is-active' : 'is-paused'}`}
          onClick={() => setActive((value) => !value)}
          title="Clique para ativar/pausar a página"
        >
          <span className="fsl-status-dot" />
          {active ? 'Página ativa' : 'Página pausada'}
        </button>
      </div>

      <p className="fsl-hero-subtitle">
        Centralize em um único link tudo que o cliente precisa para interagir
        com seu restaurante.
      </p>

      <div className="fsl-linkbar">
        <div className="fsl-linkbar-url">
          <span className="fsl-linkbar-globe" aria-hidden>
            <Globe size={17} strokeWidth={2.3} />
          </span>
          <span className="fsl-linkbar-text">
            <span className="fsl-linkbar-scheme">https://</span>
            <span className="fsl-linkbar-host">{PUBLIC_BASE}/</span>
            <span className="fsl-linkbar-slug">{slug || 'slug-do-restaurante'}</span>
          </span>
        </div>
        <div className="fsl-linkbar-actions">
          <button
            type="button"
            className="fsl-save-btn"
            onClick={handleSave}
            disabled={!hasUnsavedChanges || saving || isUploadingImage}
          >
            <Save size={16} strokeWidth={2.4} />
            {saving ? 'Salvando...' : hasUnsavedChanges ? 'Salvar alterações' : 'Tudo salvo'}
          </button>
          <button
            type="button"
            className={`fsl-copy-btn ${copied ? 'is-copied' : ''}`}
            onClick={handleCopy}
            disabled={!slug}
          >
            {copied ? <Check size={16} strokeWidth={2.6} /> : <Copy size={16} strokeWidth={2.4} />}
            {copied ? 'Copiado!' : 'Copiar link'}
          </button>
          <a
            className={`fsl-open-btn ${!slug ? 'is-disabled' : ''}`}
            href={slug ? publicPath : '#!'}
            target="_blank"
            rel="noopener noreferrer"
            onClick={slug ? undefined : (event) => event.preventDefault()}
          >
            <ExternalLink size={16} strokeWidth={2.4} />
            Abrir página
          </a>
        </div>
      </div>
      {(saving || saveError || saveMessage || isUploadingImage) && (
        <p className={`fsl-save-status ${saveError ? 'is-error' : saveMessage ? 'is-success' : ''}`}>
          {saveError || saveMessage || (isUploadingImage ? 'Enviando imagem...' : 'Salvando alterações...')}
        </p>
      )}
    </header>
  );
}
